module.exports = __webpack_public_path__ + "img/login.3253f899.svg";